"use client";

export function PageBackground() {
  return (
    <div className="fixed inset-0 z-0 overflow-hidden">
      {/* Base smooth gradient background - horizontal blue to pink/coral */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#EEF1FF] via-[#F4EEFF] to-[#FFE8F0]" />

      {/* Soft overlay gradients for depth */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_20%,rgba(99,102,241,0.08),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_30%,rgba(236,72,153,0.07),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(139,92,246,0.08),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_90%_90%,rgba(244,114,182,0.06),transparent_50%)]" />

      {/* Ultra subtle noise texture */}
      <div className="absolute inset-0 bg-[url('/images/noise.svg')] opacity-[0.02]" />
    </div>
  );
}
